import { yupResolver } from '@hookform/resolvers/yup';
import axios from 'axios';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { api } from '../../api/api.ts';
import {URLS} from "../../tools/helpers/constants.js";
import {
  favoriteInputFormSelector,
  formNameSelector,
  handleOpenModelError,
  hiddenMessage,
  mortgageCostSelector,
  mortgageInitialPaymentSelector,
  mortgageTermSelector,
  openTradeInFormSelector,
} from '../../entities/ComponentsSlice';
import { flatsLocalStorageSelector } from '../../entities/FavoriteFlatSlice';
import ButtonSend from '../../features/button-send/ButtonSend';
import InputName from '../../features/input-name/InputName';
import InputPhone from '../../features/input-phone/InputPhone';
import Textarea from '../../features/textarea/Textarea';
import ROUTES from '../../layout/routes';
import { UNIVERSAL_ADMIN } from '../../tools/helpers/constants.js';
import { timeOutPromise } from '../../tools/helpers/debounceFunction.ts';
import style from './FormCall.module.scss';
import { fetchGeneralSettings, policyFormSelector } from '../../entities/ProjectSlice';
import DOMPurify from 'isomorphic-dompurify';
import { FOS_POLICY_27825} from "../../tools/flags";

function FormCall({ classNameTitle, handleCloseFormModel, formNameProp = null, testId }) {
  const favoriteInputForm = useSelector(favoriteInputFormSelector);
  const openTradeInForm = useSelector(openTradeInFormSelector);
  const dispatch = useDispatch();
  const maskPhonePattern = /^$|^\+7 \(\d\d\d\) \d\d\d-\d\d-\d\d?$/i;
  const namePattern = /^[^-\s][а-яА-Яa-zA-Z]/;
  const phonePattern = /^$|^\+7 \([3-9]\d{2}\) \d{3}-\d{2}-\d{2}/i;
  const formName = useSelector(formNameSelector);
  const formPropName = formNameProp ? formNameProp : formName;
  const messagetoPost = useSelector(hiddenMessage);
  const flat = useSelector(state => state?.flatInfo?.flatInfo);
  const cost = useSelector(mortgageCostSelector);
  const initialPayment = useSelector(mortgageInitialPaymentSelector);
  const term = useSelector(mortgageTermSelector);
  const policyForm = useSelector(policyFormSelector);
  const { pathname } = useLocation();

  const schema = yup.object().shape({
    name: yup.string().required('Обязательное поле').matches(namePattern, 'Введите корректное имя'),

    phone: yup
      .string()
      .required('Обязательное поле')
      .matches(phonePattern, 'Введите корректный номер')
      .matches(maskPhonePattern, 'Введите корректный номер'),
    comment: yup.string(),
    ...(FOS_POLICY_27825 && { agreement: yup.bool(), newsletter_agreement: yup.bool() }),
  });

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      phone: '',
      ...(FOS_POLICY_27825 && { agreement: Boolean(policyForm.caption), newsletter_agreement: false }),
    },
  });

  const [showMessage, setShowMessage] = useState(false);
  const openMessage = () => {
    setShowMessage(true);
  };
  const closeMessage = () => {
    setShowMessage(false);
  };

  const getClassName = () => {
    if (!favoriteInputForm) return cn(style.formCallTitle, classNameTitle);
    if (favoriteInputForm && pathname.includes(ROUTES.purchaseTerms.tradeIn))
      return cn(style.formCallTitle, classNameTitle);
    return cn(style.formCallTitle, style.formCallTitle__bigForm);
  };

  const getCookie = name => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const onSubmit = async data => {
    try {
      const tokenResponse = await axios.get(`${UNIVERSAL_ADMIN.slice(0, -9)}/api/v2/get_token`);
      const token = tokenResponse.data;
      data.sessionID = token;
    } catch (error) {
      console.error('Не удалось получить токен:', error);
    }

    if (data.sessionID === undefined) {
      dispatch(handleOpenModelError(true));
      return;
    }

    data.formName = favoriteInputForm ? 'favoritesForm' : formPropName;

    if (
      openTradeInForm ||
      data.formName === 'commercialForm' ||
      data.formName === 'mortgageForm' ||
      formName === 'houseForm'
    ) {
      data.message = messagetoPost;
    }
    data.cm_data = getCookie('cm_data');
    data.comment = favoriteInputForm || openTradeInForm || formName === 'flatForm' ? getValues('comment') : '';

    if (formName === 'mortgageForm') {
      data.price = cost;
      data.initialPayment = initialPayment;
      data.loanTerm = term;
      data.page = `${process.env.REACT_APP_DOMAIN}${pathname}`;
    }

    try {
      await api.sendForm(data);
      await api.logResponseGTM({
        event: 'event-to-gtm',
        eventCategory: 'Form',
        eventAction: 'Send',
        eventLabel: 'CallBack',
      });
      reset();
      openMessage();
      await timeOutPromise(() => closeMessage(), 3000);
      await timeOutPromise(() => handleCloseFormModel(), 2000);
    } catch (error) {
      console.log(error);
      dispatch(handleOpenModelError(true));
    }
  };

  //логирование данных
  const saveReserveForm = async () => {
    const data = {
      name: getValues('name'),
      phone: getValues('phone'),
      formName: favoriteInputForm ? 'favoritesForm' : formPropName,
      comment: formName === 'flatForm' || formName === 'tradeInForm' || favoriteInputForm ? getValues('comment') : '',
      message:
        formName === 'tradeInForm' ||
        formName === 'mortgageForm' ||
        formName === 'commercialForm' ||
        formName === 'houseForm'
          ? messagetoPost
          : '',
      cm_data: getCookie('cm_data') ? getCookie('cm_data') : '',
      ...(FOS_POLICY_27825 && {
        agreement: getValues('agreement'),
        newsletter_agreement: getValues('newsletter_agreement'),
      }),
    };

    if (formName === 'mortgageForm') {
      data.price = cost;
      data.initialPayment = initialPayment;
      data.loanTerm = term;
      data.page = `${process.env.REACT_APP_DOMAIN}${pathname}`;
    }

    try {
      await api.logDataToServer(data);
    } catch (error) {
      console.log(error);
    }
  };

  const flatfavorites = useSelector(flatsLocalStorageSelector);

  let apartmentsNumbersString = '';

  useEffect(() => {
    if (flatfavorites && !pathname.includes(ROUTES.purchaseTerms.tradeIn)) {
      const localStorageArray = flatfavorites;
      localStorageArray.forEach(item => {
        if (item.apartmentNumber) {
          apartmentsNumbersString += item.apartmentNumber + ', ';
        } else apartmentsNumbersString += item.number + ', ';
      });
      apartmentsNumbersString = apartmentsNumbersString.slice(0, -2);
      if (apartmentsNumbersString !== '') {
        setValue('comment', `Меня интересуют квартиры: ${apartmentsNumbersString}`);
      }
    }
    if (formName === 'flatForm') {
      setValue(
        'comment',
        `Меня интересует квартира № ${flat.number} в корпусе ${flat.bulk.number}, площадью ${flat.area} кв.м`,
      );
    }
  }, [flatfavorites, pathname]);

  useEffect(() => {
    if (FOS_POLICY_27825 && !policyForm.caption) {
      dispatch(fetchGeneralSettings());
    }
  }, [policyForm]);


  return (
    <div
      className={
        favoriteInputForm ? cn(style.formCallContainer, style.formCallContainer__bigForm) : style.formCallContainer
      }
    >
      <div className={getClassName()}>
        <p>Оставить заявку</p>
      </div>
      {showMessage && (
        <div className={style.formCallThanksText}>
          <p>Спасибо</p>
          <p>Мы получили ваш запрос и скоро свяжемся с вами</p>
        </div>
      )}
      {!showMessage && (
        <form name='form-call' onSubmit={handleSubmit(onSubmit)} className={style.formCallForm}>
          <div className={style.formCallInputBox}>
            <InputName
              placeholder='Имя'
              label='Имя'
              register={register('name')}
              errors={Boolean(errors.name)}
              errorLabel={errors?.name?.message}
            />
          </div>
          <div className={style.formCallInputBox}>
            <Controller
              control={control}
              name='phone'
              render={({ field: { ref, ...field } }) => (
                <InputPhone
                  name='phone'
                  field={field}
                  placeholder='Телефон'
                  label='Телефон'
                  register={register('phone')}
                  errors={Boolean(errors.phone)}
                  errorLabel={errors?.phone?.message}
                />
              )}
            />
          </div>
          {(favoriteInputForm || openTradeInForm) && (
            <div className={style.formCallInputBox}>
              <Textarea
                placeholder='Сообщение'
                register={register('comment')}
                label='Сообщение'
                errors={Boolean(errors.comment)}
                errorLabel={errors?.comment?.message}
              />
            </div>
          )}
          <div className={style.formCallBtnBox}>
            <ButtonSend handleFunction={saveReserveForm} testId={testId} />
            {!FOS_POLICY_27825 && (
                <div className={style.formCallBtnText}>
                  Нажимая кнопку «Отправить», я&nbsp;даю согласие на&nbsp;обработку моих{' '}
                  <Link href={ROUTES.privacy} onClick={() => handleCloseFormModel()}>
                    персональных данных
                  </Link>{' '}
                  и&nbsp;подтверждаю согласие с&nbsp;условиями{' '}
                  <a href={URLS.DOCS_AGREEMENT} target='_blank' rel='noopener noreferrer'>
                    пользовательского соглашения
                  </a>
                </div>
            )}

            {FOS_POLICY_27825 && (
                <div className={style.formWrapper}>
                  {Boolean(policyForm.caption) && (
                      <div
                          className={style.formCallBtnText}
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(policyForm.caption) }}
                      />
                  )}

                  {Boolean(policyForm.checkbox) && (
                      <div className={`${style.checkbox} ${style.formCallBtnText}`}>
                        <input
                            id='newsletter_agreement'
                            type='checkbox'
                            className={style.checkbox__input}
                            {...register('newsletter_agreement')}
                            data-testid='newsletter_agreement-checkbox'
                        />
                        <label
                            htmlFor='newsletter_agreement'
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(policyForm.checkbox) }}
                        />
                      </div>
                  )}
                </div>
            )}
          </div>
        </form>
      )}
    </div>
  );
}

export default FormCall;
